/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
`
export default class ImageUploadIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" css={Color}>
        <g id="그룹_5349" data-name="그룹 5349" transform="translate(-978.719 -1292.75)">
          <rect id="사각형_5267" data-name="사각형 5267" width="21" height="21" transform="translate(978.719 1292.75)" fill="#eee" opacity="0"/>
          <g id="그룹_13250" data-name="그룹 13250" transform="translate(-1.021 -0.97)">
            <path id="패스_5023" className="fill" data-name="패스 5023" d="M996.921,1297.75H984.359a3.146,3.146,0,0,0-3.14,3.144v11.611a3.146,3.146,0,0,0,3.14,3.145H997.1a2.885,2.885,0,0,0,2.965-3.181v-11.574A3.146,3.146,0,0,0,996.921,1297.75Zm-9.173,8.456,2.867,2.931-.016.018,4.912,5.034H984.359a1.694,1.694,0,0,1-1.691-1.693v-1.318l4.085-4.982A.739.739,0,0,1,987.748,1306.207Zm5.187.391-1.34,1.468-2.813-2.875a2.21,2.21,0,0,0-3.09.018l-3.023,3.684v-8a1.694,1.694,0,0,1,1.691-1.693h12.561a1.694,1.694,0,0,1,1.691,1.693v8.775l-2.581-3.065-.014-.015a2.172,2.172,0,0,0-3.082.008Zm1.033,1.019a.765.765,0,0,1,.986-.04l3.657,4.344v.571l0,.058a1.8,1.8,0,0,1-.026.262c-.007.036-.017.07-.036.135s-.03.11-.049.161-.04.091-.062.138-.047.09-.073.132-.055.088-.085.129-.059.073-.1.12a1.51,1.51,0,0,1-.1.11l-.078.064a1.668,1.668,0,0,1-.507.289l-4.879-4.986Z" transform="translate(-0.4 -2.48)" fill="#eee"/>
            <path id="패스_5024" className="fill" data-name="패스 5024" d="M997.793,1302.579a2.12,2.12,0,1,0-2.12,2.12A2.122,2.122,0,0,0,997.793,1302.579Zm-1.413,0a.707.707,0,1,1-.707-.707A.707.707,0,0,1,996.38,1302.579Z" transform="translate(-0.643 -2.637)" fill="#eee"/>
          </g>
        </g>
      </svg>
    )
  }
}
